import { Component, EventEmitter, Input, Output } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

import { IIdentity, GridApi, GridSync } from '@grid/models';
import { ProjectSetup, SelectedSubproject } from '@shared/models';
import { GridBaseComponent } from '@shared/models/component';
import { DprDetails } from '@shared/models/dpr';

@UntilDestroy()
@Component({
  template: '',
})
export abstract class DprDetailsGridBaseComponent<
  T extends IIdentity
> extends GridBaseComponent<T> {
  @Input() predefinedChanges: GridSync<T>;
  @Input() selectedSubproject: SelectedSubproject;
  @Input() dprDetails: DprDetails;
  @Input() labeling: { [key: string]: string };

  @Output() dataChanged = new EventEmitter();

  get projectSetup(): ProjectSetup {
    return this.selectedSubproject?.data;
  }

  protected onGridRegistered(gridApi: GridApi<T>): void {
    gridApi.isDirty$.pipe(untilDestroyed(this)).subscribe(() => {
      this.dataChanged.emit();
    });
    gridApi.setPredefinedChanges(this.predefinedChanges);

    // timeout needed to make sure all event listeners are registered before emitting the value
    // (the issue was with the HSE registrations grid, that is otherwise initialized after emitting the value)
    setTimeout(() => {
      this.gridRegistered.emit(gridApi);
    });
  }
}
